/* @flow strict */

import * as React from 'react';

export type PropsType = {
  onClick: () => void,
  children?: React.Node
};

const Message = ({
  onClick: handleClick,
  children
}: PropsType): React.Element<'div'> => (
  <div className="Loader__wrapper">
    <span title={children}>
      <button
        className="Loader"
        onClick={handleClick}
      >
        <i
          className="Loader__icon Loader__icon--warning glyphicon glyphicon-flash"
          style={{
            fontSize: '2rem'
          }}
        />
      </button>
    </span>
  </div>
);

export default Message;
